"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKID = validateKID;
const Mod11Validator_1 = require("../Mod11Validator");
const Mod10Validator_1 = require("../Mod10Validator");
function validateKID(kidNumber) {
    if (!/^\d+$/.test(kidNumber)) {
        return false;
    }
    const { length } = kidNumber;
    if (length < 2 || length > 25) {
        return false;
    }
    const checkDigit = parseInt(kidNumber.charAt(length - 1), 10);
    const baseNumber = kidNumber.slice(0, -1);
    const baseNumberArray = baseNumber.split("").map(Number);
    const weightsForKidValidation = (0, Mod11Validator_1.getDefaultMod11WeightsForLength)(baseNumber.length);
    return (checkDigit === (0, Mod10Validator_1.calculateMod10ControlDigit)(baseNumber) ||
        checkDigit ===
            (0, Mod11Validator_1.calculateMod11CheckDigitWithWeights)(baseNumberArray, weightsForKidValidation));
}
//# sourceMappingURL=kidValidator.js.map